import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IncidentsEmptyState, IIncidentsState } from './IncidentsState';
import { IIncident } from 'interfaces/incident.interface';
import {
  fetchIncidents,
  updateSelectedIncident,
  archiveIncidentById,
  createIncident,
} from './incidentsThunk';
import { QueryState } from 'common/enums';

const initialState: IIncidentsState = IncidentsEmptyState;

export const incidentsSlice = createSlice({
  name: 'incidents',
  initialState,
  reducers: {
    resetIncidents: (state) => {
      state.incidents = [];
    },
    updateIncident: (state, action: PayloadAction<IIncident>) => {
      state.selectIncident = action.payload;
    },
    updatePage: (state, action: PayloadAction<{ PageNum: number }>) => {
      state.page = action.payload.PageNum;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchIncidents.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(fetchIncidents.fulfilled, (state, action) => {
        state.state = QueryState.READY;
        state.incidents = action.payload.incidents || [];
        state.pageTotal = action.payload.pageTotal || 0;
      })
      .addCase(fetchIncidents.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.incidents = [];
        state.error = action.error.message || 'Something went wrong';
      })
      .addCase(updateSelectedIncident.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(updateSelectedIncident.fulfilled, (state, action) => {
        state.state = QueryState.UPDATED;
        state.selectIncident = action.payload?.data;
      })
      .addCase(updateSelectedIncident.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong';
      })
      .addCase(archiveIncidentById.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(archiveIncidentById.fulfilled, (state) => {
        state.state = QueryState.UPDATED;
      })
      .addCase(archiveIncidentById.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong';
      })
      .addCase(createIncident.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(createIncident.fulfilled, (state) => {
        state.state = QueryState.CREATED;
      })
      .addCase(createIncident.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong';
      });
  },
});

export const { updateIncident, resetIncidents, updatePage } = incidentsSlice.actions;

export default incidentsSlice.reducer;
